"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeInvoiceNumber = normalizeInvoiceNumber;
exports.classifySaleLine = classifySaleLine;
exports.classifyCommissionService = classifyCommissionService;
/**
 * Commission Reconciliation — pure classification & key helpers (hvp-backend#434)
 */
const commission_reconciliation_constants_1 = require("../constants/commission-reconciliation.constants");
/**
 * Normalize an invoice/folio for cross-referencing commission ↔ sale.
 * Strips spaces, slashes and any non-alphanumeric, uppercases.
 *
 * @example
 * normalizeInvoiceNumber(" H/05355") // "H05355"
 * normalizeInvoiceNumber("H05346")   // "H05346"
 */
function normalizeInvoiceNumber(value) {
    return String(value ?? "")
        .replace(/[^A-Za-z0-9]/g, "")
        .toUpperCase();
}
/**
 * Classify a QVET sale line into a reconciliation category by its section/family.
 * Returns null when the line is outside the 4 tracked categories.
 *
 * @example
 * classifySaleLine("SERVICIOS MEDICOS", "CONSULTA") // ReconciliationCategory.consulta
 * classifySaleLine("INSUMOS ESCANDALLO", "VACUNAS") // ReconciliationCategory.vacuna
 */
function classifySaleLine(section, family) {
    const s = String(section ?? "").toUpperCase();
    const f = String(family ?? "").toUpperCase();
    if (f === "VACUNAS")
        return commission_reconciliation_constants_1.ReconciliationCategory.vacuna;
    if (s === commission_reconciliation_constants_1.SERVICIOS_MEDICOS_SECTION) {
        if (f === "CONSULTA")
            return commission_reconciliation_constants_1.ReconciliationCategory.consulta;
        if (f === "EMERGENCIA")
            return commission_reconciliation_constants_1.ReconciliationCategory.emergencia;
        if (commission_reconciliation_constants_1.SURGERY_FAMILIES.includes(f))
            return commission_reconciliation_constants_1.ReconciliationCategory.cirugia;
    }
    return null;
}
/**
 * Classify a commission service name into a reconciliation category.
 * Returns null when the service is outside the 4 tracked categories.
 */
function classifyCommissionService(serviceName) {
    if (!serviceName)
        return null;
    return commission_reconciliation_constants_1.COMMISSION_SERVICE_TO_CATEGORY[serviceName] ?? null;
}
